import { render, staticRenderFns } from "./ConnectionModalWindows.vue?vue&type=template&id=24f4796c"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalsRequestCallModal: require('/usr/src/app/components/modals/RequestCallModal.vue').default,ModalsRequestCallTaiwanModal: require('/usr/src/app/components/modals/RequestCallTaiwanModal.vue').default,ModalsQuestionModal: require('/usr/src/app/components/modals/QuestionModal.vue').default,ModalsSpotmodalModalWindow: require('/usr/src/app/components/modals/spotmodal/ModalWindow.vue').default})
